export class AnalysisContentObjectModel {
  nodeHierarchy: any[];
  nodes: any[];
  parentObjectPath: null | any;
  objectPath: null | any;
  type: string;
  objectId: null | any;
  id: null | any;
  nodesOfObject: any[];
  name: string;
  definitionPath: any;

  constructor(analysisContentObject) {
    this.id = analysisContentObject.id;
    this.objectId = analysisContentObject.objectId;
    this.name = analysisContentObject.name;
    this.type = analysisContentObject.type;
    this.objectPath = analysisContentObject.objectPath;
    this.parentObjectPath = analysisContentObject.parentObjectPath;
    this.nodes = analysisContentObject.nodes;
    this.nodesOfObject = analysisContentObject.nodesOfObject;
    this.nodeHierarchy = analysisContentObject.nodeHierarchy || [];

    this._buildNodeHierarchy();
  }

  addNode(node, isDescendent, parentNode) {
    let objectNode = this.findNode(node);

    if (!objectNode) {
      objectNode = {
        id: node.id,
        exclude: false,
        isDescendent: isDescendent,
        objectId: node.objectId,
        name: node.name,
        fullName: node.fullName,
        childNodes: [],
      };

      this.nodes.push(objectNode);
      if (parentNode) parentNode.childNodes.push(objectNode);
      else this.nodeHierarchy.push(objectNode);
    }
    return objectNode;
  }

  addNodeAndDescendents(node, isDescendent, parentNode) {
    let objectNode = this.addNode(node, isDescendent || false, parentNode);
    for (let i = 0; i < node.items.length; i++) {
      this.addNodeAndDescendents(node.items[i], true, objectNode);
    }
  }

  findNodeById(nodes, id, field, childrenField): any {
    nodes.forEach((node) => {
      if (node[field] === id) return node;

      if (node[childrenField]) {
        let descendent = this.findNodeById(node[childrenField], id, field, childrenField);
        // @ts-ignore
        if (descendent) return descendent;
      }
    });
  }

  removeNonExistingNodes(nodeHierarchy) {
    this.nodes.forEach((node, i) => {
      // @ts-ignore
      !this.findNodeById(nodeHierarchy, node.id, 'id', 'items') && this.nodes.splice(i, 1);
    });
  }

  clearNodes() {
    this.nodes.splice(0);
    this.nodesOfObject.splice(0);
    this.nodeHierarchy.splice(0);
  }

  removeNode(nodeId) {
    let remove = -1;
    this.nodes.find(function (item, index) {
      let isEq = item.id === nodeId;
      if (isEq) remove = index;
      return isEq;
    });
    if (remove > -1) {
      this.nodes.splice(remove, 1);
    }
  }

  nodesFor(objectId) {
    let id = parseInt(objectId);
    if (!isNaN(id)) return this.nodes.filter((item) => item.objectId === id && !item.exclude);
  }

  childNodes(nodeId) {
    let node = this.findNode(nodeId);
    if (!node) return [];
    return node.childNodes.filter((item) => !item.exclude);
  }

  _loadChildNodesBypassGroups(loadInto, node) {
    node.childNodes.forEach((child) => {
      if (child.isGroup) {
        this._loadChildNodesBypassGroups(loadInto, child);
      } else {
        if (!child.exclude) loadInto.push(child);
      }
    });
  }

  childNodesBypassGroups(nodeId) {
    let node = this.findNode(nodeId);
    if (!node) return [];

    let childNodes = [];
    this._loadChildNodesBypassGroups(childNodes, node);
    return childNodes;
  }

  nodesForCategoryTypeLevel(categoryTypeId, categoryLevel) {
    let categoryNodes = [];
    this.nodes.forEach((node) => {
      !node.exclude && node.categoryTypeId === categoryTypeId && node.categoryLevel === categoryLevel && categoryNodes.push(node);
    });
    return categoryNodes;
  }

  nodesForType(type) {
    return this.nodes.filter(function (item) {
      return item.type === type && !item.exclude;
    });
  }

  findNode(nodeId) {
    let id = parseInt(nodeId);
    if (!isNaN(id)) return this.nodes.find((item) => item.id === id);
  }

  _buildNodeHierarchy() {
    for (let i = 0; i < this.nodes.length; i++) {
      let node = this.nodes[i];
      node.childNodes = node.childNodes || [];

      if (!node.parentId) {
        this.nodeHierarchy.push(node);
        continue;
      }

      let parent = this.nodes.find(function (item) {
        return item.id === node.parentId;
      });
      if (parent) {
        parent.childNodes = parent.childNodes || [];
        parent.childNodes.push(node);
        node.parentNode = parent;
      } else this.nodeHierarchy.push(node);
    }
  }

  toCommand() {
    let cmd = {
      id: this.id,
      objectId: this.objectId,
      objectPath: this.objectPath,
      parentObjectPath: this.parentObjectPath,
      definitionPath: this.definitionPath,
      nodes: [],
    };

    this.nodes.forEach((node) => {
      cmd.nodes.push({ id: node.id, isDescendent: node.isDescendent, exclude: node.exclude });
    });
    return cmd;
  }

  fromNode(node) {
    this.objectId = node.objectId;
    this.name = node.name;
    return this;
  }
}

export default AnalysisContentObjectModel;
